export const uniform = {
  $01: '#fdfeff',
  $02: '#fbfeff',
  $03: '#f8fcfe',
  $04: '#f0f9fd',
  $05: '#e2f4fb',
  $06: '#d6e8ee',
  $07: '#cbdbe1',
} as const;
